define('models/metrik_user',['require','backbone'],function (require) {
  var Backbone = require("backbone");

  return Backbone.Model.extend({
    url: function () {

     var url_with_customer = App.Config.apiBase +"metrik-users/" + this.id + "/?customer_id=" + this.attributes.customer_id;
     var url_with_id = App.Config.apiBase + "metrik-users/" + this.id + "/";

      return this.id ? (this.attributes.customer_id ? url_with_customer : url_with_id) : 
        App.Config.apiBase + "metrik-users/";
    },

    defaults: function () {
      return {
        first_name: "",
        last_name: "",
        email: null,
        is_activated: false,
        allow_gdpr: true,
      };
    },
  });
});

